import type {Thread} from '../store/thread';

export type QueueAction = 'wait' | 'drain' | 'pause' | 'hold';

export interface ComputeNextActionInput {
  status: Thread['status'];
  pendingQuestions: boolean;
  pendingNetworkAccessRequest: boolean;
  resumeRequested: boolean;
  steerRequested: boolean;
  readonly: boolean;
}

/** computeNextAction decides what a thread's queue should do next. */
export function computeNextAction(input: ComputeNextActionInput): QueueAction {
  if (input.status === 'running') {
    return 'wait';
  }
  if (input.readonly) {
    return 'hold';
  }
  // An explicit force-send overrides the cancelled/errored/pending pauses; it
  // still waits through a live turn or in-flight cancel (both `running`) and
  // respects readonly, handled above.
  if (input.steerRequested) {
    return 'drain';
  }

  // TODO(WB-48149): Once the HITL catalog stack lands, derive this from
  // resolveComposerBlock instead of manually OR-ing each pending field.
  const hasPending =
    input.pendingQuestions || input.pendingNetworkAccessRequest;
  if (hasPending && !input.resumeRequested) {
    return 'pause';
  }

  return 'drain';
}
